import baseSiteTheme from '../Base/baseSiteTheme'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import Hero from './Components/Hero'
import RealPeopleSection from './Components/RealPeopleSection'
import CommittedSection from './Components/CommittedSection'
import LegitBusinessSection from './Components/LegitBusinessSection'
import HopeThisClearsUpSection from './Components/HopeThisClearsUpSection'

const LegitPage = () => {
    const baseUrl = window.React.base_url

    return (
        <MuiThemeProvider theme={baseSiteTheme}>
            <Hero />
            <LegitBusinessSection baseUrl={baseUrl} />
            <RealPeopleSection baseUrl={baseUrl} />
            <CommittedSection baseUrl={baseUrl} />
            <HopeThisClearsUpSection baseUrl={baseUrl} />
        </MuiThemeProvider>
    )
}

export default LegitPage
